import type { SecuritySettingsFeatureConfig } from '../type';

export const securitySettingsConfig: Partial<SecuritySettingsFeatureConfig> = {
    alternateExternalClientId: 'gstore',
    externalTargets: ['alias', 'limits', 'password'],
};
